// How numbers, money and dates read across the app

const money = new Intl.NumberFormat("en-GH", {
  style: "currency",
  currency: "GHS",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const number = new Intl.NumberFormat("en-GH", { maximumFractionDigits: 2 });

export const formatMoney = (value) => money.format(Number(value) || 0);

export const formatNumber = (value) => number.format(Number(value) || 0);

export const escapeHtml = (value) =>
  String(value ?? "").replace(
    /[&<>"']/g,
    (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch],
  );
